import React from "react";
import {
    Table,
    TableRow,
    TableHead,
    TableBody,
    TableCell,
    IconButton
} from "@mui/material";

import {
    Delete as DeleteIcon
} from "@mui/icons-material";

import styles from "./hoverableStyles.module.css"

import { useTranslation } from "react-i18next"

export default function DeviceBlacklistTable({ data, handleEditReason, handleRemove }) {
    const { t } = useTranslation();

    var keys = ["#", t("Alarm"), t("Reason")];

    return (
        <Table size="small">
            <TableHead>
                <TableRow>
                    {keys.map(key => (
                        <TableCell key={key} style={{ fontWeight: 'bold' }}>{key}</TableCell>
                    ))}
                </TableRow>
            </TableHead>
            <TableBody>
                {data.map(entry => (
                    <TableRow key={entry.id}>
                        <TableCell className={styles.cell}>
                            <IconButton
                                style={{ color: 'red' }}
                                onClick={() => handleRemove(entry)} >
                                <DeleteIcon />
                            </IconButton>
                            {entry.id}
                        </TableCell>
                        <TableCell className={styles.cell}>{entry.devId}</TableCell>
                        <TableCell
                            className={styles.hoverableCell}
                            onClick={() => handleEditReason(entry)}
                        >
                            {entry.reason}
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
}
